import React from "react";
import { Check } from "lucide-react";
import { PPF_OPTIONS } from "@/lib/vehicles";

/**
 * Mandatory vehicle question: "Is your vehicle already covered with PPF coating?"
 * Two big tap targets instead of a dropdown: nothing to open, nothing that can hide behind a pop-up, one tap to answer.
 * Value is "yes" | "no" | "" (same as before), so every screen that uses it keeps working.
 */
export default function PpfQuestion({ value, onChange, className = "", testId = "ppf-question" }) {
  const choose = (v) => onChange?.(v);
  const move = (e, i) => {                       // arrow keys move between the two answers, like a native radio group
    if (!["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp"].includes(e.key)) return;
    e.preventDefault();
    const next = PPF_OPTIONS[(i + (e.key === "ArrowRight" || e.key === "ArrowDown" ? 1 : PPF_OPTIONS.length - 1)) % PPF_OPTIONS.length];
    choose(next.value);
    document.getElementById(`${testId}-${next.value}`)?.focus();
  };
  return (
    <div className={className} data-testid={testId} role="radiogroup" aria-labelledby={`${testId}-label`} aria-required="true">
      <span id={`${testId}-label`} className="text-sm font-medium">Is your vehicle already covered with PPF coating? <span className="text-destructive">*</span></span>
      <p className="mt-0.5 text-xs text-muted-foreground">PPF is a clear paint-protection film applied over the paint. Not sure? Pick “No”.</p>
      <div className="mt-2 grid grid-cols-2 gap-2">
        {PPF_OPTIONS.map((o, i) => {
          const [title, sub] = o.label.split(" - ");
          const on = value === o.value;
          return (
            <button
              key={o.value} id={`${testId}-${o.value}`} type="button" role="radio" aria-checked={on}
              tabIndex={on || (!value && i === 0) ? 0 : -1}
              data-testid={`${testId}-${o.value}`}
              onClick={() => choose(o.value)} onKeyDown={(e) => move(e, i)}
              className={`relative min-h-[3.5rem] rounded-xl border-2 px-3 py-2.5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ${on ? "border-primary bg-primary/10" : "border-border bg-background hover:border-primary/50"}`}
            >
              <span className="block text-sm font-semibold">{title}</span>
              <span className="block text-xs leading-snug text-muted-foreground">{sub}</span>
              {on && <span className="absolute right-2 top-2 grid h-5 w-5 place-items-center rounded-full bg-primary text-primary-foreground"><Check className="h-3.5 w-3.5" aria-hidden="true" /></span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
